// components/EmptyState.js
import React from 'react';
import { Upload } from 'lucide-react';
import Papa from 'papaparse';
import { processLogbookWithErrors } from '@utils/logbookUtils.js';

export const EmptyState = ({ onDataLoaded }) => {
  const handleFileUpload = (file) => {
    if (!file.name.endsWith('.csv')) {
      alert('Please upload a CSV file exported from theCrag.');
      return;
    }

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function(results) {
        try {
          const { processed, errors } = processLogbookWithErrors(results.data);
          if (!processed || processed.length === 0) {
            throw new Error('No valid data after processing');
          }
          // Add filename to each record
          const dataWithFilename = processed.map(record => ({
            ...record,
            filename: file.name,
            _processingErrors: errors // Attach errors to the data array
          }));
          
          // Just pass the data - errors are attached to it
          onDataLoaded(dataWithFilename);
        } catch (error) {
          alert('Error processing data: ' + error.message);
        }
      },
      error: function(error) {
        alert('Error reading file: ' + error.message);
      }
    });
  };

  return (
    <div className="w-full">
      <div className="bg-white shadow-lg rounded-lg p-8 text-center">
        <h2 className="text-2xl font-semibold mb-4">AscentStats Climbing Dashboard</h2>
        <p className="text-gray-600 mb-8">Upload your logbook from theCrag to get started</p>
        
        <div 
          className="max-w-lg mx-auto border-2 border-dashed border-gray-300 rounded-lg p-8 cursor-pointer hover:border-gray-400 transition-colors"
          onClick={() => document.getElementById('file-input').click()}
        >
          <Upload className="mx-auto mb-4 text-gray-400" size={32} />
          <p className="text-lg mb-2">Click to upload or drag and drop</p>
          <p className="text-sm text-gray-500">CSV file exported from theCrag</p>
          <input
            id="file-input"
            type="file"
            accept=".csv"
            className="hidden"
            onChange={(event) => handleFileUpload(event.target.files[0])}
          />
        </div>
      </div>
    </div>
  );
};